/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { EInvoicingSettingsUpdateRequest } from './';
import {
    EInvoicingSettingsUpdateRequestFromJSON,
    EInvoicingSettingsUpdateRequestFromJSONTyped,
    EInvoicingSettingsUpdateRequestToJSON,
} from './';
import type { InvoiceMailingSettingsUpdateRequest } from './';
import {
    InvoiceMailingSettingsUpdateRequestFromJSON,
    InvoiceMailingSettingsUpdateRequestFromJSONTyped,
    InvoiceMailingSettingsUpdateRequestToJSON,
} from './';
import type { InvoicingSettingsUpdateRequest } from './';
import {
    InvoicingSettingsUpdateRequestFromJSON,
    InvoicingSettingsUpdateRequestFromJSONTyped,
    InvoicingSettingsUpdateRequestToJSON,
} from './';
import type { PaymentSettingsUpdateRequest } from './';
import {
    PaymentSettingsUpdateRequestFromJSON,
    PaymentSettingsUpdateRequestFromJSONTyped,
    PaymentSettingsUpdateRequestToJSON,
} from './';
import type { QuoteSettingsUpdateRequest } from './';
import {
    QuoteSettingsUpdateRequestFromJSON,
    QuoteSettingsUpdateRequestFromJSONTyped,
    QuoteSettingsUpdateRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface LegalEntityPreferencesRequest
 */
export interface LegalEntityPreferencesRequest {
    /**
     * 
     * @type {PaymentSettingsUpdateRequest}
     * @memberof LegalEntityPreferencesRequest
     */
    paymentSettings: PaymentSettingsUpdateRequest;
    /**
     * 
     * @type {InvoicingSettingsUpdateRequest}
     * @memberof LegalEntityPreferencesRequest
     */
    invoicingSettings: InvoicingSettingsUpdateRequest;
    /**
     * 
     * @type {QuoteSettingsUpdateRequest}
     * @memberof LegalEntityPreferencesRequest
     */
    quoteSettings: QuoteSettingsUpdateRequest;
    /**
     * 
     * @type {EInvoicingSettingsUpdateRequest}
     * @memberof LegalEntityPreferencesRequest
     */
    eInvoicingSettings: EInvoicingSettingsUpdateRequest;
    /**
     * 
     * @type {InvoiceMailingSettingsUpdateRequest}
     * @memberof LegalEntityPreferencesRequest
     */
    invoiceMailingSettings?: InvoiceMailingSettingsUpdateRequest;
}

/**
 * Check if a given object implements the LegalEntityPreferencesRequest interface.
 */
export function instanceOfLegalEntityPreferencesRequest(value: object): value is LegalEntityPreferencesRequest {
    if (!('paymentSettings' in value) || value['paymentSettings'] === undefined) return false;
    if (!('invoicingSettings' in value) || value['invoicingSettings'] === undefined) return false;
    if (!('quoteSettings' in value) || value['quoteSettings'] === undefined) return false;
    if (!('eInvoicingSettings' in value) || value['eInvoicingSettings'] === undefined) return false;
    return true;
}

export function LegalEntityPreferencesRequestFromJSON(json: any): LegalEntityPreferencesRequest {
    return LegalEntityPreferencesRequestFromJSONTyped(json, false);
}

export function LegalEntityPreferencesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalEntityPreferencesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentSettings': PaymentSettingsUpdateRequestFromJSON(json['paymentSettings']),
        'invoicingSettings': InvoicingSettingsUpdateRequestFromJSON(json['invoicingSettings']),
        'quoteSettings': QuoteSettingsUpdateRequestFromJSON(json['quoteSettings']),
        'eInvoicingSettings': EInvoicingSettingsUpdateRequestFromJSON(json['eInvoicingSettings']),
        'invoiceMailingSettings': json['invoiceMailingSettings'] == null ? undefined : InvoiceMailingSettingsUpdateRequestFromJSON(json['invoiceMailingSettings']),
    };
}

export function LegalEntityPreferencesRequestToJSON(value?: LegalEntityPreferencesRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'paymentSettings': PaymentSettingsUpdateRequestToJSON(value['paymentSettings']),
        'invoicingSettings': InvoicingSettingsUpdateRequestToJSON(value['invoicingSettings']),
        'quoteSettings': QuoteSettingsUpdateRequestToJSON(value['quoteSettings']),
        'eInvoicingSettings': EInvoicingSettingsUpdateRequestToJSON(value['eInvoicingSettings']),
        'invoiceMailingSettings': InvoiceMailingSettingsUpdateRequestToJSON(value['invoiceMailingSettings']),
    };
}

